/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
import { useIdioma } from "stores/idiomaStore";
// chakra imports

export function SidebarLinks(props) {
  // Chakra color mode
  let location = useLocation();
  const { t } = useIdioma();

  const { routes } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (route.hideInSidebar) {
        return null;
      }
      if (
        route.layout === "/admin" ||
        route.layout === "/auth" ||
        route.layout === "/rtl"
      ) {
        return (
          <React.Fragment key={index}>
            {route.sidebarSectionTitle ? (
              <li className="mb-1 list-none px-8 pt-2">
                <span className="mb-3 block border-t border-gray-200 pt-5 text-[10px] font-bold uppercase tracking-[0.18em] text-gray-400 dark:border-white/10 dark:text-gray-500">
                  {route.sidebarSectionTitle}
                </span>
              </li>
            ) : null}
            {route.sidebarTopBorder ? (
              <li className="list-none px-8 pt-3" aria-hidden>
                <div className="border-t border-gray-200 dark:border-white/10" />
              </li>
            ) : null}
            <Link to={route.layout + "/" + route.path}>
              <div className="relative mb-3 flex hover:cursor-pointer">
                <li className="my-[3px] flex cursor-pointer items-center px-8">
                  <span
                    className={`${
                      activeRoute(route.path) === true
                        ? "font-bold text-brand-500 dark:text-white"
                        : "font-medium text-gray-600"
                    }`}
                  >
                    {route.icon ? route.icon : <DashIcon />}{" "}
                  </span>
                  <p
                    className={`leading-1 ml-4 flex ${
                      activeRoute(route.path) === true
                        ? "font-bold text-navy-700 dark:text-white"
                        : "font-medium text-gray-600"
                    }`}
                  >
                    {route.claveI18n ? t(route.claveI18n, route.name) : route.name}
                  </p>
                </li>
                {activeRoute(route.path) ? (
                  <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
                ) : null}
              </div>
            </Link>
          </React.Fragment>
        );
      }
      return null;
    });
  };
  // BRAND
  return createLinks(routes);
}

export default SidebarLinks;
